import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

/**Local component */
import { LoginComponent } from './login/login.component';

/** Query file */
import {
    ReportReviewQueryService
} from '../gql-query-mutation/index';

/**Service file */

import { AuthService } from './auth.service';

const routes = [
    {
        path: 'login',
        component: LoginComponent,
        resolve: [
            AuthService
        ]
    }
];

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        RouterModule.forChild(routes),
    ],
    exports: [
        LoginComponent
    ],
    providers: [
        AuthService,
        ReportReviewQueryService
    ]
})

export class AuthModule {

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/auth/auth.module.ts